import React from "react";

import styles from "./Main.module.css";

const Main = ({ content }) => {
  return <section className={styles.main}>{content}</section>;
};

export default Main;
